"use client";

import Link from "next/link";

import { formatDonorDisplayName } from "@/lib/donor-name";
import { cn } from "@/lib/utils";

const linkClassName =
  "min-w-0 truncate text-sm font-semibold text-foreground underline decoration-solid underline-offset-2 hover:text-foreground";

type DonorDisplayProps = {
  donorId?: number | null;
  firstName?: string | null;
  lastName?: string | null;
  onPreload?: (donorId: number) => void;
  className?: string;
};

/** Underlined donor name link — matches the Donors table name column. */
export function DonorDisplay({
  donorId,
  firstName,
  lastName,
  onPreload,
  className,
}: DonorDisplayProps) {
  const name = formatDonorDisplayName(firstName, lastName);

  if (donorId == null || donorId <= 0) {
    return (
      <span
        className={cn(
          "min-w-0 truncate text-sm font-semibold text-foreground",
          className,
        )}
      >
        {name}
      </span>
    );
  }

  return (
    <Link
      href={`/donors/${donorId}`}
      className={cn(linkClassName, className)}
      onMouseEnter={() => onPreload?.(donorId)}
      onFocus={() => onPreload?.(donorId)}
    >
      {name}
    </Link>
  );
}
